import { useState, useEffect } from "react";
// import OpenAITest from './OpenAITest';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TarotReader from "./TarotReader.jsx";
import HomePage from "./HomePage.jsx"; // Import the new HomePage

function App() {
  // --- Dark Mode Logic ---
  const [theme, setTheme] = useState(() => {
    // Check localStorage first
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      return savedTheme;
    }
    // Fallback to system preference
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.style.colorScheme = theme; // Explicitly set color-scheme style
    if (theme === "dark") {
      root.classList.add("dark");
      root.classList.remove("light"); // Explicitly remove light
    } else {
      root.classList.remove("dark");
      root.classList.add("light"); // Explicitly add light
    }
    // Save theme preference to localStorage
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Example function to toggle theme (can be passed down or used here)
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  };
  // --- End Dark Mode Logic ---

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/tarot" element={<TarotReader />} />
    </Routes>
  );
  // return <TarotReader />;
  // return <OpenAITest />;
}

export default App;
